var map = {
	"./en.json": 1138,
	"./es-US.json": 1139,
	"./fr-CA.json": 1140
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1790;



//////////////////
// WEBPACK FOOTER
// ./src/v2/language ^\.\/.*\.json$
// module id = 1790
// module chunks = 0